import React from 'react';
/**
 * DjayAvatar part — mouth per emotion.
 * Verbatim extraction of the former `renderMouth()` (incl. the `showMouth`
 * size gate and `showDetails` happy-mouth fill).
 */
import type { DjayEmotion, VariantColorScheme } from '../types';
interface MouthProps {
  emotion: DjayEmotion;
  colors: VariantColorScheme;
  showMouth: boolean;
  showDetails: boolean;
}
export function Mouth({
  emotion,
  colors,
  showMouth,
  showDetails
}: MouthProps) {
  if (!showMouth) return null;
  switch (emotion) {
    case 'excited':
    case 'celebrating':
    case 'proud':
      return <g className="djay-mouth" data-id="element-3493" data-mp="2dh6gqtoz1k66">
          <path d="M80 130 Q100 165 120 130 Z" fill={colors.mouthColor} data-id="element-3494" data-mp="2dg4v5vabxfa7" />
          <path d="M90 145 Q100 155 110 145 Z" fill="#EF4444" data-id="element-3495" data-mp="28id5l7x5q596" />
        </g>;
    case 'surprised':
      return <g className="djay-mouth" data-id="element-3496" data-mp="35xzc8hhr4iwu">
          <ellipse cx="100" cy="138" rx="6" ry="10" fill={colors.mouthColor} data-id="element-3497" data-mp="35z21kkzfedan" />
        </g>;
    case 'thinking':
      return <g className="djay-mouth" data-id="element-3498" data-mp="315fvjbnrp7nt">
          <path d="M90 135 Q95 132 100 135 T110 135" stroke={colors.mouthColor} strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-3499" data-mp="3q30tpido7384" />
          
        </g>;
    case 'sleeping':
      return <g className="djay-mouth" data-id="element-3500" data-mp="3u66vacpu8689">
          <path d="M95 138 Q100 142 105 138" stroke={colors.mouthColor} strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-3501" data-mp="3gdqyvurfz6gb" />
          
        </g>;
    case 'pointing':
      return <g className="djay-mouth" data-id="element-3502" data-mp="36ers6hq8lkvy">
          <path d="M90 135 Q105 142 115 130" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3503" data-mp="36dqc1yud687d" />
          
        </g>;
    case 'encouraging':
      return <g className="djay-mouth" data-id="element-3504" data-mp="2xemrsrjgnmra">
          <path d="M85 135 Q100 145 115 135" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3505" data-mp="2xfo5l3rv2ncp" />
          
        </g>;
    case 'happy':
    default:
      return <g className="djay-mouth" data-id="element-3506" data-mp="vnrwe0t61pl3">
          <path d="M82 133 Q100 152 118 133" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3507" data-mp="vknho9i2rbg6" />
          
          {showDetails && <path d="M85 134 Q100 148 115 134" fill={colors.mouthColor} fillOpacity="0.15" data-id="element-3508" data-mp="y7eon9iq3nw2" />}
        </g>;
  }
}